import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import './tools.css'
import { isIOs, isMobile, getVideo } from '../../misc/selectors'
import { extractFromUrl, cancel } from '../../actions'
import VideoProgress from '../../misc/videoProgress/VideoProgress.js'
import { processUploadedFiles } from '../../misc/utilities'

const mapStateToProps = (state, ownProps) => {
  const { videos, me, tools } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
    tempVideo: getVideo(videos.cache, tools.tempcode), 
  }
}

class Tool extends Component {
  fileInput = React.createRef();
  urlInput = React.createRef();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.file != prevProps.file) {
      this.gotFile(this.props.file)
    }
    if (this.props.url != prevProps.url) {
      this.gotUrl(this.props.url)
    }
  }

  async gotFile(file) {
    const { me, dispatch, } = this.props

    processUploadedFiles(dispatch, [file], null, me.plan_max_length, me.plan_max_size, 'embed')
    .then(() => {
      this.formRef.reset()
    })
  }

  gotUrl(url) {
    browserHistory.push(`/clipper?upload_source=embed&url=${url}`)
  }

  render() {
    const {dispatch, tempVideo, action } = this.props
    const self = this
    return (
      <div className="tool">
        <form style={{ display: 'none' }}>
          <input
            id="upload-input"
            multiple={!this.props.isIOs}
            type="file"
            ref={this.fileInput}
            accept={this.props.isMobile ? "video/*" : null}
            onChange={() => {
              const files = this.fileInput.current.files
              this.gotFile(files[0])
            }}
          />
        </form>
        <div className="header">
            <div>
                <h1>Embed Video</h1>
                <p>Embed your video on any website in seconds using this free online tool.</p>
            </div>
        </div>
        {tempVideo ?
          <VideoProgress video={tempVideo} onCancel={_ => dispatch(cancel(tempVideo))} />
        : ''}
        <form
          className="form start-form"

        >
          <div className="upload-pane">
            <a
              className="upload-button"
              href="/signup"
            >Sign up now — it's free!</a>
            
          </div>
        </form>
        <div className="info-section">
          <p>This is a free tool from <Link to="/">Streamable</Link>, the video hosting service for online creatives that's loved by over 50 million users across the globe.</p>
          <p>The embed code works with every file format, from MP4 video to MOV video, and is free for videos up to 10 min or 250 MB. Ditch the limits with a <Link to="/upgrade">free trial</Link> of Pro.</p>
        </div>
        <div className="preview-section">
          <iframe src="https://streamable.com/e/z1plzy" frameborder="0" width="600" height="337" allow="fullscreen"></iframe>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Tool)
